import { Capacitor } from "@capacitor/core";
import {
  createWebDownloadSupportShareProvider,
  type SupportMailRequest,
  type SupportShareProvider,
} from "@yjsgames/support-contact";

/**
 * 문의 공유 Provider 결정 (DIP 플랫폼 분기 팩토리) — `createAccountLinkProvider`와 동형.
 * - Android/iOS: `CapacitorSupportShareProvider`(native share sheet + 로그 파일 첨부) — `void import()`로
 *   로드(웹 번들에서 네이티브 SDK 제외).
 * - 웹: 로그 `.log` 파일 **다운로드만**(브라우저는 메일 첨부 자동화 불가). 수신 주소는 모달 문구로 안내.
 */
export function createSupportShareProvider(): SupportShareProvider {
  const platform = Capacitor.getPlatform();
  if (platform === "android" || platform === "ios") {
    return nativeFacade(() =>
      import("./CapacitorSupportShareProvider.js").then(
        ({ CapacitorSupportShareProvider }) => new CapacitorSupportShareProvider(),
      ),
    );
  }
  return createWebDownloadSupportShareProvider();
}

/** 네이티브 어댑터 facade — 로드 완료 후 share 위임. 미로드 시 로드 후 1회 share(부팅 시 로드라 실상 즉시). */
function nativeFacade(loader: () => Promise<SupportShareProvider>): SupportShareProvider {
  let active: SupportShareProvider | null = null;
  void loader().then((p) => {
    active = p;
  });
  return {
    share: (req: SupportMailRequest) => {
      if (active) active.share(req);
      else void loader().then((p) => p.share(req));
    },
  };
}
